export const PROJECT_DOMAIN = {
  PROD: ['partner.xiaojukeji.com', 'partner.xxhuoyun.com'],
  PRE: ['partner-pre.xiaojukeji.com'],
  SIM: ['partner-test.xiaojukeji.com'],
};
